const footGroups = [
  {
    title: "栏目直达",
    links: [
      { href: "#hot", label: "今日热帖" },
      { href: "#category", label: "热门栏目" },
      { href: "#feature", label: "深读话题" },
      { href: "#submit", label: "匿名投稿" },
    ],
  },
  {
    title: "了解平台",
    links: [
      { href: "#about", label: "关于我们" },
      { href: "#rule", label: "吃瓜守则" },
      { href: "#rule", label: "常见问题" },
      { href: "#top", label: "回到顶部" },
    ],
  },
];

export default function Footer() {
  return (
    <>
      <section className="px-4 pb-16 md:px-8">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-6 overflow-hidden rounded-3xl bg-primary-500 px-6 py-10 text-center md:flex-row md:px-12 md:text-left">
          <div>
            <p className="text-xs font-medium tracking-wide text-primary-100">
              心里那句没处说的话
            </p>
            <h2 className="mt-2 font-heading text-2xl font-semibold text-background-50 md:text-3xl">
              现在，就把它轻轻放下吧
            </h2>
          </div>
          <a
            href="#submit"
            className="inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-full bg-background-50 px-8 py-3.5 text-base font-medium text-primary-600 transition-colors hover:bg-accent-300 hover:text-foreground-950"
          >
            <i className="ri-send-plane-fill mr-2" aria-hidden="true" />
            匿名投稿
          </a>
        </div>
      </section>

      <footer className="bg-background-200">
        <div className="mx-auto max-w-6xl px-4 py-14 md:px-8">
          <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
            <div>
              <a href="#top" className="flex items-center gap-2.5">
                <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-lg text-background-50">
                  <i className="ri-water-flash-line" aria-hidden="true" />
                </span>
                <span className="font-heading text-xl font-medium text-foreground-950">
                  校园吃瓜网
                </span>
              </a>
              <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
                面向在校大学生的匿名分享社区。身边事、小吐槽、被暖到的瞬间——
                想说又不想露脸的话，都可以放心投给我们。
              </p>
              <p className="mt-4 inline-flex items-center gap-2 rounded-full bg-background-50 px-3 py-1.5 text-sm text-foreground-700">
                <i className="ri-mail-send-line text-primary-600" aria-hidden="true" />
                hi@xiaoyuanchigua.cn
              </p>
            </div>

            {footGroups.map((g) => (
              <nav key={g.title} aria-label={g.title}>
                <p className="font-heading text-base font-semibold text-foreground-950">
                  {g.title}
                </p>
                <ul className="mt-4 space-y-3">
                  {g.links.map((l) => (
                    <li key={l.label + l.href}>
                      <a
                        href={l.href}
                        className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                      >
                        {l.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </nav>
            ))}
          </div>
        </div>

        <div className="border-t border-background-300">
          <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 px-4 py-6 text-xs text-foreground-600 sm:flex-row md:px-8">
            <p>© 2026 校园吃瓜网 · 友善表达，认真倾听</p>
            <p className="inline-flex items-center gap-1.5">
              <i className="ri-heart-fill text-primary-500" aria-hidden="true" />
              只聊事不聊人，做有温度的校园树洞
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}